export class CourseSurveyAnswer {
  public id: number;
  public answer?: string;
  public answerId?: number;
  public question: string;
  public questionId: number;
  public savedItem: boolean;
}
